<template>
  <div>
    <page-header></page-header>

    <div class="fullscreen-card">
      <progress-bar :percentage="25"></progress-bar>

      <form class="form-horizontal">
        <uiv-tabs v-model="step.tabIndex" ref="tabs" class="tabs--hide">
          <uiv-tab title="home">
            <home></home>
          </uiv-tab>

          <uiv-tab title="paymentType">
            <payment-type></payment-type>
          </uiv-tab>

          <uiv-tab title="supplierTariff">
            <supplier-tariff />
          </uiv-tab>

          <uiv-tab title="usage">
            <usage />
          </uiv-tab>
        </uiv-tabs>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import PageHeader from '@/components/page-header/PageHeader';
import PageSteps from '@/components/page-steps/PageSteps';
import ProgressBar from '@/components/progress/ProgressBar';
import Home from '@/components/current-tariff/Home';
import PaymentType from '@/components/current-tariff/PaymentType';
import SupplierTariff from '@/components/current-tariff/SupplierTariff';
import Usage from '@/components/current-tariff/Usage';

export default {
  name: 'CurrentTariff',
  async mounted() {
    this.$store.commit('quote/resetState');
    this.$store.commit('lookups/resetState');
    this.$store.commit('storage/reset');
    this.$store.dispatch('quote_questions/getQuestions', this.$refs.tabs.$children);
    await this.$store.dispatch('token/getToken');
    await this.$store.dispatch('quote/getCustomer', this.$route.params.customerId);

    this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Current Tariff' });
    this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    this.$store.dispatch('tracing/saveActions');
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      step: ({ quote_questions }) => quote_questions.step
    })
  },
  methods: {
    ...mapActions({
      getQuestions: 'quote_questions/getQuestions'
    })
  },
  components: {
    PageHeader,
    PageSteps,
    ProgressBar,

    Home,
    PaymentType,
    SupplierTariff,
    Usage
  }
};
</script>

<style lang="scss"></style>
